// extracted by mini-css-extract-plugin
export var chevronIcon = "_dz-2";
export var teamName = "_dz-1";
export var teamSwitcherButton = "_dz-0";